import { render, staticRenderFns } from "./blacklists.vue?vue&type=template&id=169fcfcb&"
import script from "./blacklists.vue?vue&type=script&lang=js&"
export * from "./blacklists.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports